import React from 'react';
import FirebaseLoginForm from './components/FirebaseLoginForm';

const Login = ({ location }) => {
  const { from } = location.state || { from: { pathname: '/' } }

  return (
    <FirebaseLoginForm from={from} />
  )
}

export default Login;



// WEBPACK FOOTER //
// ./src/scenes/Login/index.js